module.exports = __webpack_public_path__ + "img/T6-C-xh_11.fa1ba350.png";